<template>
  <v-list flat class="pa-0">
    <v-list-item
      active-class="border"
      @click="onReservePageRoute(item)"
      v-if="checkMenuVisible('linkToDetails')"
    >
      <v-icon color="dark3Grey"> mdi-logout</v-icon>
      <v-list-item-title>상세 페이지로 이동 </v-list-item-title>
    </v-list-item>
    <v-list-item
      active-class="border"
      @click="onOpenManualReservation(item)"
      v-if="checkMenuVisible('changeReservation')"
    >
      <v-icon color="dark3Grey">mdi-logout</v-icon>
      <v-list-item-title> 예약 변경 </v-list-item-title>
    </v-list-item>
    <v-list-item
      active-class="border"
      @click="onCancelReservationBind(item)"
      v-if="checkMenuVisible('cancelReservation')"
    >
      <v-icon color="dark3Grey">mdi-logout</v-icon>
      <v-list-item-title> 예약 취소 </v-list-item-title>
    </v-list-item>
    <v-list-item
      active-class="border"
      @click="onCancelRestReservationCallbackOpen(item)"
      v-if="checkMenuVisible('cancelRest')"
    >
      <v-icon color="dark3Grey">mdi-logout</v-icon>
      <v-list-item-title> 휴식 취소 </v-list-item-title>
    </v-list-item>
    <v-list-item active-class="border"
                 @click="onDeliveryPageRoute(item.id)"
                 v-if="checkMenuVisible('linkToDeliveryDetails')">
      <v-icon color="dark3Grey"> mdi-logout</v-icon>
      <v-list-item-title>상세 페이지로 이동 </v-list-item-title>
    </v-list-item>
    <v-list-item active-class="border"
                 @click="onCancelDelivery(item.id)"
                 v-if="checkMenuVisible('cancelDelivery')">
      <v-icon color="dark3Grey"> mdi-logout</v-icon>
      <v-list-item-title>예약 취소 </v-list-item-title>
    </v-list-item>
  </v-list>
</template>
<script>
export default {
  props: {
    schedule: {
      type: Object,
    },
    onReservePageRoute: {
      type: Function,
    },
    onOpenManualReservation: {
      type: Function,
    },
    onCancelReservationBind: {
      type: Function,
    },
    onCancelRestReservationCallbackOpen: {
      type: Function,
    },
    onDeliveryPageRoute: {
      type: Function,
    },
    onCancelDelivery: {
      type: Function,
    }
  },
  computed: {
    item() {
      return this.schedule.item.item;
    }
  },
  methods: {
    checkMenuVisible(menuItem) {
      switch (menuItem) {
        case "linkToDetails":
          return (
            this.schedule.item.category !== 'delivery' &&
            this.item.customerName !== "휴식" &&
            this.item.departure !== "휴식" &&
            this.item.destination !== "휴식"
          );
        case "cancelRest":
          return (
            this.item.customerName === "휴식" &&
            this.item.departure === "휴식" &&
            this.item.destination === "휴식"
          );
        case "changeReservation":
          return (
            this.item.customerName !== this.item.departure &&
            this.item.customerName !== this.item.destination &&
            this.item.resrvState.configValue === "rs_complete"
          );
        case "cancelReservation":
          return (
            this.item.customerName !== this.item.departure &&
            this.item.customerName !== this.item.destination &&
            this.item.resrvState.configValue === "rs_complete"
          );
        case "linkToDeliveryDetails":
          return (
            this.schedule.item.category === 'delivery'
          );
        case "cancelDelivery":
          return (
              this.schedule.item.category === 'delivery' &&
              this.item.state.configValue === 'dvry_to_be_done'
          );
      }
    },
  },
  mounted() {},
};
</script>